import React, {useEffect, useState} from "react"
import api from "../services/apiClient";
import AuthService from '../services/authentication'
import { useOrder } from '../data/order'

import {useFavourites} from '../data/favourites'

import ProductCard from "./ProductCard"
import ProductSearchForm from "./ProductSearchForm"
import ProductModal from "./ProductModal"
import Pagination from "./Pagination"

import MixtureImage from 'images/mixture_image.png'

import { TabGroup, TabList, Tab, TabPanels, TabPanel } from "@headlessui/react"
import { cn } from "../ui"

function ProductSearchIndex(props) {

  let for_mixture = props.variant == 'mixture'
  const [products, setProducts] = useState([])
  const [searchParams, setSearchParams] = useState({query: '', category_ids: [], brands: []});
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [totalCount, setTotalCount] = useState(0)
  const [selectedProduct, setSelectedProduct] = useState({})
  const [productModalShow, setProductModalShow] = useState(false)
  let auth = AuthService.useAuth()
  const {favouriteProducts, isLoading, isError} = useFavourites(auth.authHeader())
  const { order } = useOrder(auth.authHeader())

  const fetchProducts = (params = searchParams, page = page) => {
    return (
      api.get('/api/products/search', {
        headers: auth.authHeader(),
        params: {
          ...params,
          page: page,
          for_mixture: for_mixture
        }
      })
    )
  }

  useEffect(() => {
    setPage(1)
    fetchProducts(searchParams, 0)
    .then(response => {
      setProducts(response.data.products || response.data)
      if (response.data.total_pages) {
        setTotalPages(response.data.total_pages)
      }
      if (response.data.total_count !== undefined) {
        setTotalCount(response.data.total_count)
      }
    })
    .catch(error => {
      console.log(error)
    })
  }, [])

  const handleShowModalClick = product => {
    setSelectedProduct(product)
    setProductModalShow(true)
  }

  const handleSearchSubmit = params => {
    setSearchParams(params)
    setPage(1)
    fetchProducts(params, 0)
    .then(response => {
      setProducts(response.data.products || response.data)
      if (response.data.total_pages) {
        setTotalPages(response.data.total_pages)
      }
      if (response.data.total_count !== undefined) {
        setTotalCount(response.data.total_count)
      }
    })
    .catch(error => {
      console.log(error)
    })
  }

  const handlePageChange = (newPage) => {
    // Scroll to top immediately before fetching to avoid race conditions with React rendering
    window.scrollTo({ top: 0, behavior: 'auto' })

    setPage(newPage)
    // Backend uses 0-indexed pages, UI uses 1-indexed
    fetchProducts(searchParams, newPage - 1)
    .then(response => {
      setProducts(response.data.products || response.data)
      if (response.data.total_pages) {
        setTotalPages(response.data.total_pages)
      }
      if (response.data.total_count !== undefined) {
        setTotalCount(response.data.total_count)
      }
    })
    .catch(error => {
      console.log(error)
    })
  }

  const renderProductCards = products => {
    return products.map((product, i) => {
      return (
        <div key={i} className="self-stretch">
          <ProductCard
            product={product}
            onShowModalClick={product => handleShowModalClick(product)}
            for_mixture={for_mixture}
            mixtureId={props.mixtureId}
          />
        </div>
      )
    })
  }

  const renderMixtureCard = () => {
    const mixtureProduct = [{
      id: 'MIXTURE',
      brand: "Integria",
      mixture: true,
      name: 'Custom Herbal Formulation',
      image_url: MixtureImage,
      description: 'Custom-made herbal tonics for your patients. Formulated by you and blended by our in-house team of qualified and experienced Naturopaths. You can rest assured the quality of your tonics are paramount to our Dispensary team. We exclusively use MediHerb liquids in your formulations as these are the global gold-standard of herbal liquid extracts and undergo rigorous quality control measures during their manufacturing process. We do not compromise on quality to ensure you and your patients get the best results. Add this product to your prescription, and customise the formulation to meet your patient’s needs.'
    }]
    return renderProductCards(mixtureProduct)
  }

  const tabClassName = ({ selected }) =>
    cn(
      "px-4 py-2 font-medium border-b-2 -mb-px focus:outline-none",
      selected
        ? "border-integria-green text-integria-green"
        : "border-transparent text-gray-500 hover:text-gray-700"
    )

  return (
    <div className=" white-bg">
    <TabGroup>
        <TabList className="flex gap-2 border-b border-gray-200 mb-3">
          <Tab className={tabClassName}>Search</Tab>
          <Tab className={tabClassName}>Favourites</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <div>
              <ProductSearchForm
                products={products}
                onSearchSubmit={handleSearchSubmit}
                for_mixture={for_mixture}
              />
            </div>
            <div>
              <div className={cn("grid grid-cols-1 sm:grid-cols-2 gap-4 mb-3", for_mixture ? "xl:grid-cols-2" : "xl:grid-cols-4")}>
                {!for_mixture && order && order.practitioner && order.practitioner.company_code != 'ihal' && page === 1 && renderMixtureCard()}
                {Object.keys(products).length != 0 && renderProductCards(products)}
              </div>
              <Pagination
                currentPage={page}
                totalPages={totalPages}
                totalCount={totalCount}
                onPageChange={handlePageChange}
              />
            </div>
          </TabPanel>
          <TabPanel>
            {!isLoading && !isError &&
              <>
              <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 mb-3" style={{paddingBottom: '500px'}}>
                {favouriteProducts && Object.keys(favouriteProducts).length != 0 && renderProductCards(favouriteProducts, isLoading, isError)}
              </div>
              {Object.keys(favouriteProducts, isLoading, isError).length == 0 && <h3 style={{paddingBottom: '1000px'}} className="text-gray-500">Favourites can be added from the product search tab..</h3>}
              </>
            }
          </TabPanel>
        </TabPanels>
      </TabGroup>
      <ProductModal
        show={productModalShow}
        onHide={() => setProductModalShow(false)}
        product={selectedProduct}
      />
      </div>
  )
}

export default ProductSearchIndex
